import { ProductType } from 'src/common/interfaces/Tenant';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

import { buildMobileScansListVariables } from './helpers/buildVariables';
import { transformMobileScansListResults } from './helpers/transformResults';
import { MFA_SCANS_LIST_QUERY, MSDK_SCANS_LIST_QUERY } from './MobileScansList.query';
import {
	IGetMobileScansListParams,
	IMobileScansListQuery,
	IMobileScansListResult,
	MobileScansProductType
} from './MobileScansList.types';

const getQuery = (productName?: MobileScansProductType): string =>
	productName === ProductType.MOBILE_SDK ? MSDK_SCANS_LIST_QUERY : MFA_SCANS_LIST_QUERY;

export const getMobileScansList = async (
	params: IGetMobileScansListParams
): Promise<IMobileScansListResult> => {
	try {
		const variables = buildMobileScansListVariables(params);
		const result = await gqlClient.request<IMobileScansListQuery>(
			getQuery(params.productName),
			variables
		);

		return transformMobileScansListResults(result, params.productName);
	} catch (error) {
		Logger.error('MobileScansListService -> getMobileScansList failed with an error:', error);
		throw error;
	}
};
